// Todo valor monetário do sistema é um inteiro em centavos. Estas funções são a única
// ponte entre centavos e texto: exibição em R$, campos de formulário e CSV.

const formatoBRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

/** 600 → "R$ 6,00" (com espaço não separável, como o Intl gera). */
export function formatarReais(centavos: number): string {
  return formatoBRL.format(centavos / 100);
}

/** 123456 → "1234,56" — sem símbolo nem separador de milhar (CSV e campos de formulário). */
export function formatarDecimal(centavos: number): string {
  const sinal = centavos < 0 ? "-" : "";
  const abs = Math.abs(Math.trunc(centavos));
  return `${sinal}${Math.trunc(abs / 100)},${String(abs % 100).padStart(2, "0")}`;
}

/** 123456 → "1.234,56" — como o valor aparece nos campos com máscara. */
export function formatarMilhar(centavos: number): string {
  const abs = Math.abs(Math.trunc(centavos));
  const reais = String(Math.trunc(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${centavos < 0 ? "-" : ""}${reais},${String(abs % 100).padStart(2, "0")}`;
}

/**
 * Máscara de dinheiro: só os dígitos contam e preenchem da direita, como em maquininha
 * ("1" → 0,01; "1250" → 12,50). Sem nenhum dígito, devolve null (campo vazio).
 */
export function centavosDaMascara(texto: string, maximoDigitos = 9): number | null {
  const digitos = texto.replace(/\D/g, "").replace(/^0+(?=\d)/, "").slice(0, maximoDigitos);
  return digitos ? Number(digitos) : null;
}

/**
 * Lê um valor digitado em reais e devolve centavos, ou null se não for um valor válido.
 * Aceita "6", "6,5", "6,50", "1.234,56", "R$ 6,00" e também "6.50" (ponto como decimal
 * quando há só um ponto seguido de 1 ou 2 dígitos). Nunca passa por número de ponto flutuante.
 */
export function parseReais(texto: string): number | null {
  let s = texto.replace(/R\$/gi, "").replace(/\s/g, "");
  if (!s) return null;
  if (s.includes(",")) {
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (!/^\d+\.\d{1,2}$/.test(s)) {
    s = s.replace(/\./g, "");
  }
  const m = /^(\d+)(?:\.(\d{1,2}))?$/.exec(s);
  if (!m) return null;
  const inteiro = m[1] ?? "0";
  const fracao = (m[2] ?? "").padEnd(2, "0");
  if (inteiro.length > 9) return null;
  return Number(inteiro) * 100 + Number(fracao);
}
